/** Who a center's entitlements belong to: they are the plan narrowed by THIS user's role. */
export const entitlementUserKey = (user) => (user ? String(user.id ?? user.email ?? '') || null : null)
